/** Opciones alineadas con legacy (ng2-toastr CustomToastrOption). */
export const toastrRootConfig = {
  positionClass: 'toast-bottom-right' as const,
  timeOut: 4000,
  closeButton: false,
  progressBar: false,
  preventDuplicates: true,
};
